import React from 'react'
import Icon from "../../../assets/images/brush.png"
import ProcessIcon1 from "../../../assets/images/process-icon-1.png"
import ProcessIcon2 from "../../../assets/images/process-icon-2.png"
import ProcessIcon3 from "../../../assets/images/process-icon-3.png"
import StarIcon from "../../../assets/images/bg/contact-bg2.png"

const Process = () => {
    return (
        <div>
            <div className="rs-process process-style1 process-about-style pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="sec-title2 mb-10 text-center">
                        <div className="brush-content center-text mb-20">
                            <img src={Icon} alt="" />
                            <span className="sub-text">How It Works</span>
                        </div>
                        <h2 className="title pb-35">
                            Easiest Way to Get Our<br />
                            Service
                        </h2>
                    </div>
                    <div className="all-process-item">
                        <div className="row">
                            <div className="col-lg-4 md-mb-40">
                                <div className="process-item">
                                    <div className="icon-image">
                                        <img src={ProcessIcon1} alt="Images" />
                                    </div>
                                    <div className="number-area">
                                        01
                                    </div>
                                    <div className="content-txt">
                                        <h3 className="number-title">Contact Us</h3>
                                        <p className="number-txt mb-3">
                                            Reach out to us via phone, email, or our online contact form. Let us know your cleaning needs, and our friendly team will guide you through the process.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 md-mb-40">
                                <div className="process-item">
                                    <div className="icon-image">
                                        <img src={ProcessIcon2} alt="Images" />
                                    </div>
                                    <div className="number-area number-two">
                                        02
                                    </div>
                                    <div className="content-txt">
                                        <h3 className="number-title">Flexible Scheduling</h3>
                                        <p className="number-txt mb-3">
                                            We work around your schedule to minimize disruptions. Whether you need daily, weekly, or one-time cleaning, we’ll ensure our services fit seamlessly into your routine.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="process-item">
                                    <div className="icon-image">
                                        <img src={ProcessIcon3} alt="Images" />
                                    </div>
                                    <div className="number-area">
                                        03
                                    </div>
                                    <div className="content-txt">
                                        <h3 className="number-title">Tailored Cleaning Services</h3>
                                        <p className="number-txt">
                                            Once you approve the plan, our professional team will get to work. Every service is tailored to meet your unique needs, delivering spotless results with precision and care.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="process-animate">
                    <div className="process-style left-side">
                        <img src={StarIcon} alt="Process" />
                    </div>
                    <div className="process-style right-side">
                        <img src={StarIcon} alt="Process" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Process
